import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice from "../slices/authSlice";

import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import appSlice from "../slices/appSlice";

const persistConfig = {
  key: "root",
  storage: storage,
}

const rootReducer = combineReducers({
  authSlice,
  app:appSlice,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  // middleware: [],
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store)


